import React from "react"
import { Link } from "react-router-dom"
import { Star, MessageSquare } from "lucide-react"

const testimonials = [
  {
    name: "Sameer Khattak",
    comment:
      "Great service, technicians were very polite and efficient. They arrived on time and completed the job perfectly.",
    date: "01-02-2023 10:00 PM",
  },
  {
    name: "Michael Anwar",
    comment:
      "Never had maintenance been so easy! Turning out to be a reliable service. I've recommended Hazer to all my friends.",
    date: "01-03-2023 09:00 AM",
  },
  {
    name: "Amy Shehzad",
    comment:
      "Service is good and quality with the work of technicians. The app makes booking and tracking so convenient.",
    date: "01-04-2023 02:30 PM",
  },
]

const TestimonialsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-center mb-4 text-[#0072bc]">Our Customers Speak for Us!</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-12">
          Don't just take our word for it. Here's what our satisfied customers have to say about our services.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="relative bg-white rounded-lg p-8 shadow-lg border-t-4 border-[#ffa726]">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="h-12 w-12 rounded-full bg-[#0072bc] flex items-center justify-center text-white text-xl font-bold shadow-md">
                  {testimonial.name.charAt(0)}
                </div>
              </div>

              <div className="pt-6">
                <div className="flex justify-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>

                <p className="text-gray-600 mb-4 italic">"{testimonial.comment}"</p>

                <div className="pt-4 border-t">
                  <h3 className="font-bold text-[#0072bc]">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#f0f8ff] p-6 rounded-lg max-w-3xl mx-auto shadow-md">
          <div className="flex items-center justify-center mb-4">
            <MessageSquare className="h-8 w-8 text-[#0072bc] mr-2" />
            <h3 className="text-xl font-bold text-[#0072bc]">Share Your Experience</h3>
          </div>
          <p className="text-gray-600 mb-4">
            We value your feedback! Let us know about your experience with our services.
          </p>
          <Link
            to="/leave-review"
            className="inline-flex items-center rounded-md bg-[#ffa726] px-6 py-3 text-sm font-medium text-white hover:bg-[#ff9800] transition-colors"
          >
            Leave a Review
          </Link>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection